<template>
  <div id="content" class="col-lg-12">
    <div class="row">
    <div id="sections" class="col-xl-2 col-lg-12 col-md-12 col-sm-12 col-12" v-if="isLogged">
      <div class="titre">
        <span><b>Liste des classeurs</b></span>
        <span v-on:click="isHiddenAddSection = !isHiddenAddSection" class="logo fas fa-plus"></span>
      </div>
      <!-- Erreurs dans un formulaire -->
      <b-alert
        :show="dismissCountDownDanger"
        dismissible
        variant="danger"
        @dismissed="dismissCountDownDanger=0"
        @dismiss-count-down="countDownChangedDanger"
      >
        <span v-for="error in errors" v-bind:key="error.id">
          {{ error }}
        </span>
      </b-alert>
      <!-- Succès dans un formulaire -->
      <b-alert
        :show="dismissCountDownSuccess"
        dismissible
        variant="success"
        @dismissed="dismissCountDownSuccess=0"
        @dismiss-count-down="countDownChangedSuccess"
      >
        {{ successMessage }}
      </b-alert>
      <!-- Formulaire d'ajout d'une note -->
      <div v-if="!isHiddenAddNote" id="ajouterNote">
        <form id="addnote" @submit="addNote" method="post" >
          <fieldset>
            <legend @click="hideFormNoteToAdd()" class="pointer textAjout" @mouseover="hoverAddNote = true" @mouseleave="hoverAddNote = false">Ajouter une note
              <span v-if="hoverAddNote" class="toClose">click to close</span>
            </legend>
            <div class="input-group mb-3">
              <div class="input-group-prepend">
                <span class="input-group-text textLabelForm" id="note_name">Nom</span>
              </div>
              <input v-model="note_name" type="text" class="form-control" aria-describedby="note_name">
              <input id="section_note_id" name="section_note_id" type="hidden" v-model="section_note_id">
            </div>
            <button class="btn btn-primary button-right" type="submit">Créer</button>
          </fieldset>
        </form>
      </div>
      <!-- Formulaire d'ajout d'une section -->
      <div v-if="!isHiddenAddSection" id="ajouterSection">
        <form id="addsection" @submit="addSection" method="post">
          <fieldset>
          <legend @click="hideFormSectionToAdd()" class="pointer textAjout" @mouseover="hoverAddSection = true" @mouseleave="hoverAddSection = false">Ajouter un classeur
            <span v-if="hoverAddSection" class="toClose">click to close</span>
          </legend>
            <div class="input-group mb-3">
              <div class="input-group-prepend">
                <span class="input-group-text textLabelForm" id="section_name">Nom</span>
              </div>
              <input v-model="section_name" type="text" class="form-control" aria-describedby="section_name">
            </div>
            <div class="input-group mb-3">
              <div class="input-group-prepend"><span class="input-group-text textLabelForm">Description</span></div>
              <textarea v-model="section_small_description" class="form-control" aria-label="Description" name="section_small_description" id="small_description"></textarea>
            </div>
            <button class="btn btn-primary button-right" type="submit">Créer</button>
          </fieldset>
        </form>
      </div>
      <!-- Formulaire de modification d'une section -->
      <div v-if="!isHiddenModifySection" id="modifierSection">
        <form id="modifysection" @submit="modifySection" method="post">
          <fieldset>
          <legend @click="hideFormSectionToModify()" class="pointer textAjout" @mouseover="hoverModifySection = true" @mouseleave="hoverModifySection = false">Modifier le classeur
            <span v-if="hoverModifySection" class="toClose">click to close</span>
          </legend>
            <div class="input-group mb-3">
              <div class="input-group-prepend">
                <span class="input-group-text textLabelForm" id="section_name">Nom</span>
              </div>
              <input v-model="section_name" type="text" class="form-control" aria-describedby="section_name">
            </div>
            <div class="input-group mb-3">
              <div class="input-group-prepend"><span class="input-group-text textLabelForm">Description</span></div>
              <textarea v-model="section_small_description" class="form-control" aria-label="Description" name="section_small_description" id="small_description"></textarea>
            </div>
            <input id="section_id_modify" name="section_id_modify" type="hidden" v-model="section_id">
            <button class="btn btn-primary button-right" type="submit">Valider</button>
          </fieldset>
        </form>
      </div>
      <!-- Directive v-if with !isErrorState() -->
      <div v-if="!isErrorState()">
        <div class="sections-liste" v-for="eachSection in sectionsList" v-bind:key="eachSection.id">
          <div class="sectionName">
            <span v-b-tooltip.hover.righttop :title="eachSection.small_description" class="nomSection"><b>{{ eachSection.name }}</b></span>
            <!-- Afficher les actions -->
            <div class="btn-group pointer actions">
              <span class="fas fa-th-list" @click="showActions(eachSection.id)" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"></span>
              <div :id=eachSection.id class="dropdown-menu">
                <!-- Dropdown menu links -->
                <a class="dropdown-item" href="#" v-on:click="getNoteIntercalaire(eachSection.id)">Lister les notes</a>
                <a class="dropdown-item" href="#" v-on:click="displayFormNoteToAdd(eachSection.id)">Ajouter une note</a>
                <a class="dropdown-item" href="#" v-on:click="moveSection(eachSection.id, 'up')">Déplacer vers le haut</a>
                <a class="dropdown-item" href="#" v-on:click="moveSection(eachSection.id, 'down')">Déplacer vers le bas</a>
                <a class="dropdown-item" href="#" v-on:click="displayFormModifySection(eachSection.id)">Modifier le classeur</a>
                <a class="dropdown-item" href="#" v-on:click="deleteSection(eachSection.id)">Supprimer le classeur</a>
              </div>
            </div>
          </div>
          <div class="notes-liste" v-for="eachNote in notesList" v-bind:key="eachNote.noteId" @click="selectedNote(eachNote.noteId, eachSection.id)">
            <div v-if="eachNote.sectionId == eachSection.id">
              <ul>
                <li :class="eachNote.noteId">{{ eachNote.noteName }}</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <!-- Directive v-else -->
      <div v-if="isErrorState()" class="error-message alert alert-danger" role="alert">{{ errorMessage }}</div>
    </div>
    <notes />
    </div>
  </div>
</template>

<script>
// Add dependency to AXIO JavaScript library
import axios from 'axios'
import Notes from './Notes.vue'
import { bus } from './../../event-bus.js'
import { mapGetters } from 'vuex'
import $ from 'jquery'

export default {
  name: 'sections',
  components: { Notes },
  data: () => {
    return {
      state: '',
      errorMessage: '',
      isHiddenAddSection: true,
      isHiddenAddNote: true,
      isHiddenModifySection: true,
      sectionsList: [],
      notesList: [],
      errors: [],
      section_name: '',
      section_small_description: '',
      note_name: '',
      section_note_id: '',
      section_id: '',
      successMessage: '',
      dismissSecs: 4,
      dismissCountDownSuccess: 0,
      dismissCountDownDanger: 0,
      hoverAddNote: false,
      hoverAddSection: false,
      hoverModifySection: false
    }
  },
  created () {
    this.listerSections()
    bus.$on('updateIntercalaire', (sectionId) => {
      this.getNoteIntercalaire(sectionId)
    })
  },
  computed: mapGetters([
    'isLogged'
  ]),
  methods: {
    countDownChangedSuccess (dismissCountDownSuccess) {
      this.dismissCountDownSuccess = dismissCountDownSuccess
    },
    countDownChangedDanger (dismissCountDownDanger) {
      this.dismissCountDownDanger = dismissCountDownDanger
    },
    showSuccess () {
      this.dismissCountDownSuccess = this.dismissSecs
    },
    showError () {
      this.dismissCountDownDanger = this.dismissSecs
    },
    showActions (element) {
      if ($('#' + element).hasClass('show') === true) {
        $('#' + element).removeClass('show')
      } else {
        if ($(window).width() > 1024) {
          $('#' + element).parent().addClass('dropright')
        } else {
          $('#' + element).parent().addClass('dropleft')
        }
        $('#' + element).addClass('show')
      }
    },
    listerSections () {
      // Liste des sections via API :
      axios.get('sections')
        .then(response => {
          this.sectionsList = response.data.sections
          this.state = 'succes'
        })
        .catch(error => {
          this.state = 'error'
          this.errorMessage = error
        })
    },
    isErrorState () {
      return this.state === 'error'
    },
    displayFormNoteToAdd: function (sectionId) {
      $('#' + sectionId).removeClass('show')
      this.isHiddenAddNote = !this.isHiddenAddNote
      this.section_note_id = sectionId
    },
    hideFormNoteToAdd: function () {
      this.isHiddenAddNote = !this.isHiddenAddNote
    },
    hideFormSectionToAdd: function () {
      this.isHiddenAddSection = !this.isHiddenAddSection
    },
    displayFormModifySection: function (sectionId) {
      $('#' + sectionId).removeClass('show')
      this.isHiddenModifySection = !this.isHiddenModifySection
      this.section_id = sectionId
      axios.get('sections/' + sectionId)
        .then(response => {
          $('#' + sectionId).removeClass('show')
          if (response.data.status === 1) {
            this.state = 'error'
            this.errorMessage = response.data.status_message
          }
          if (response.data.status === 0) {
            this.section_name = response.data.content.name
            this.section_small_description = response.data.content.small_description
            this.state = 'succes'
          }
        })
        /*
        .catch(error => {
          console.log(error)
        })
        */
    },
    hideFormSectionToModify: function () {
      this.isHiddenModifySection = !this.isHiddenModifySection
    },
    moveSection: function (sectionId, sens) {
      axios.get('sections/' + sectionId + '/order/' + sens)
        .then(response => {
          $('#' + sectionId).removeClass('show')
          if (response.data.status === 1) {
            this.state = 'error'
            this.errorMessage = 'Error : sections can not be loaded.'
          }
          if (response.data.status === 0) {
            this.sectionsList = response.data.sections
            this.state = 'succes'
          }
        })
        /*
        .catch(error => {
          console.log(error)
        })
        */
    },
    getNoteIntercalaire: function (sectionId) {
      $('#' + sectionId).removeClass('show')
      axios.get('sections/intercalaire/' + sectionId)
        .then(response => {
          this.notesList = response.data.intercalaires
        })
        /*
        .catch(error => {
          console.log(error)
        })
        */
    },
    addNote: function (e) {
      e.preventDefault()

      this.errors = []
      this.successMessage = ''

      if (this.note_name === '') {
        this.errors.push('Nom de la note requis.')
      }
      if (this.note_name.length > 30) {
        this.errors.push('Nom de la note trop long.')
      }
      if (this.errors.length === 0) {
        axios.post('notes', {
          section_id: this.section_note_id,
          name: this.note_name
        })
          .then(response => {
            if (response.data.status === 1) {
              this.errors = []
              this.errors.push(response.data.status_message)
              this.showError()
              $('#' + this.section_note_id).removeClass('show')
            }
            if (response.data.status === 0) {
              this.successMessage = response.data.status_message
              this.showSuccess()
              this.notesList.push(response.data.content)
            }
            this.note_name = ''
            this.isHiddenAddNote = true
          })
          /*
          .catch(error => {
            console.log(error)
          })
          */
      }
    },
    checkDataSections: function () {
      if (this.section_name === '') {
        this.errors.push('Nom du classeur requis.')
      }
      if (this.section_name.length > 40) {
        this.errors.push('Nom du classeur trop long.')
      }
      if (this.section_small_description === '') {
        this.errors.push('Une petite description est requise.')
      }
      if (this.section_small_description.length > 765) {
        this.errors.push('La petite description trop longue.')
      }
    },
    addSection: function (e) {
      e.preventDefault()

      this.errors = []
      this.successMessage = ''

      this.checkDataSections()

      if (this.errors.length > 0) {
        this.showError()
      }
      if (this.errors.length === 0) {
        axios.post('sections', {
          name: this.section_name,
          small_description: this.section_small_description
        })
          .then(response => {
            if (response.data.status === 1) {
              this.errors = []
              this.errors.push(response.data.status_message)
              this.showError()
            }
            if (response.data.status === 0) {
              this.successMessage = response.data.status_message
              this.showSuccess()
              this.sectionsList.push(response.data.content)
            }
            this.section_name = ''
            this.section_small_description = ''
            this.isHiddenAddSection = true
          })
          /*
          .catch(error => {
            console.log(error)
          })
          */
      }
    },
    modifySection: function (e) {
      e.preventDefault()

      this.errors = []
      this.successMessage = ''

      this.checkDataSections()

      if (this.errors.length > 0) {
        this.showError()
      }
      if (this.errors.length === 0) {
        axios.put('sections/' + this.section_id, {
          name: this.section_name,
          small_description: this.section_small_description
        })
          .then(response => {
            if (response.data.status === 1) {
              this.errors = []
              this.errors.push(response.data.status_message)
              this.showError()
            }
            if (response.data.status === 0) {
              this.successMessage = response.data.status_message
              this.showSuccess()
              this.sectionsList = response.data.content
            }
            this.isHiddenModifySection = true
          })
          /*
          .catch(error => {
            console.log(error)
          })
          */
      }
    },
    selectedNote (noteId, sectionId) {
      let intercalaireId = noteId + '#' + sectionId
      bus.$emit('selectedNote', intercalaireId)
    },
    deleteSection: function (sectionId) {
      $('#' + sectionId).removeClass('show')
      axios.delete('sections/' + sectionId)
        .then(response => {
          if (response.data.status === 1) {
            this.errors.push(response.data.status_message)
            this.showError()
            $('#' + sectionId).removeClass('show')
          }
          if (response.data.status === 0) {
            for (var i = 0; i < this.sectionsList.length; i++) {
              if (this.sectionsList[i]['id'] === sectionId) {
                this.sectionsList.splice(i, 1)
              }
            }
            this.successMessage = response.data.status_message
            this.showSuccess()
          }
        })
        /*
        .catch(error => {
          console.log(error)
        })
        */
    }
  }
}
</script>

<style scoped>
  #sections {
    background-color: blueviolet;
    color: cornsilk;
    min-height: 800px;
  }

  #ajouterSection  {
    display: block;
    text-align: left;
    border-radius: 10px;
    border-width: 2px;
    border-style: solid;
    border-color: cornsilk;
    padding: 10px;
    margin-top: 10px;
    margin-bottom: 10px;
  }

  #modifierSection  {
    display: block;
    text-align: left;
    border-radius: 10px;
    border-width: 2px;
    border-style: solid;
    border-color: cornsilk;
    padding: 10px;
    margin-top: 10px;
    margin-bottom: 10px;
  }

  .titre .fa-plus {
    color: #e0da1b;
  }

  .nomSection {
    color: #e0da1b;
  }

  .actions .fa-th-list {
    color: cornsilk;
  }

  #ajouterNote {
    display: block;
    text-align: left;
    border-radius: 10px;
    border-width: 2px;;
    border-style: solid;
    border-color: cornsilk;
    padding: 10px;
    margin-top: 10px;
    margin-bottom: 10px;
  }

  .actions {
    float: right;
  }

  .fa-th-list {
    color: cornsilk;
    padding: 5px;
  }

  .sections-liste {
    text-align: left;
    margin-top: 15px;
  }

  .logo {
    padding: 5px;
    vertical-align: middle;
    float: right;
    cursor: pointer;
  }

  .button-right {
    float: right;
    margin-right: 15px;
  }

  .pointer {
    cursor: pointer;
  }

  .selected {
    color: #e0da1b;
  }

  .toClose {
    font-size: x-small;
    color: gray;
  }

  .textAjout {
    font-size: medium;
  }

  .tooltip {
    opacity: 1;
  }

  .textLabelForm {
    font-size: x-small;
    background-color: blueviolet;
    color: white;
  }

  .input-group > .custom-select:not(:last-child), .input-group > .form-control:not(:last-child) {
    border-bottom-right-radius: 5px;
    border-top-right-radius: 5px;
  }

  .input-group-text {
    padding: 5px;
  }

  .notes-liste li {
    cursor: pointer;
  }

  .notes-liste ul {
    margin-bottom: 6px;
    margin-top: 6px;
  }

  #ajouterSection .btn {
    background-color: white;
    color: blueviolet;
  }

  #modifierSection .btn {
    background-color: white;
    color: blueviolet;
  }

  #ajouterNote .btn {
    background-color: white;
    color: blueviolet;
  }

  .dropdown-item {
    font-size: 0.75em;
    color: cornsilk;
  }

  .dropdown-item:hover {
    color: burlywood;
  }

  .dropdown-menu {
    background-color: blueviolet;
    border-color: white;
    margin-left: 4px;
  }

  @media screen and (max-width: 600px) {
    .sectionName {
      font-size: 4vw;
      color: #e0da1b;
    }

    #sections {
      min-height: 0px;
    }

    #note {
      min-height: 150px;
    }

    #sections .titre {
      font-size: 3.5vw;
    }
  }

  @media screen and (min-width: 600px) and (max-width: 1024px) {
    .sectionName {
      font-size: 2vw;
      color: #e0da1b;
    }

    #sections {
      min-height: 0px;
    }

    #note {
      min-height: 150px;
    }

    #sections .titre {
      font-size: 1.75vw;
    }
  }

  @media screen and (min-width: 1025px) {
    .sectionName {
      font-size: 1vw;
      color: #e0da1b;
    }

    #sections {
      min-height: 800px;
    }

    #note {
      min-height: 100px;
    }
  }

  @media print {
    #sections {
      display: none;
    }
  }
</style>
